<template>
  <b-container fluid>
     <b-row>
       <b-col cols="12">
         <h3>{{ $t('LNG_SUPPORT', this.lang) }}</h3>
       </b-col>
     </b-row>
     
     <b-row v-if="notSentError">
       <b-col cols="8" offset="2">
         <b-alert variant="danger" show>{{$t('LNG_MESSAGE_NOT_SENT', this.lang)}}</b-alert>
       </b-col>
     </b-row>
     <b-row v-if="notSent">
       <b-col cols="8" offset="2">
           <b-form-textarea
             v-model="myMessage"
             id="myMessage"
             ref="myMessage"
             :placeholder="$t('LNG_YOUR_MESSAGE', this.lang)"
             :rows="10"
             :max-rows="100" class="mb-3">
           </b-form-textarea>
           <vue-recaptcha sitekey="6Lc6FFoUAAAAACPewmO49WouIZm6Jmim6TKKLLcE" @verify="okC"></vue-recaptcha>
           <b-button type="button" variant="evaobj" v-on:click.prevent="onSubmit()" v-if="displaySendMessage">{{ $t('LNG_SEND', lang) }}</b-button>
           <b-button type="button" v-on:click.prevent="exit()">{{ $t('LNG_CLOSE', lang) }}</b-button>
       </b-col>
    </b-row>
    
    <b-row v-if="!notSent">
    <b-col cols="8" offset="2">
      <b-alert variant="success" show>{{$t('LNG_MESSAGE_SENT', this.lang)}}</b-alert>
      <b-button type="button" v-on:click.prevent="exit()">{{ $t('LNG_CLOSE', lang) }}</b-button>
    </b-col>
 </b-row>
 
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { focus } from 'vue-focus'
import VueRecaptcha from 'vue-recaptcha'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'support',
  components: {
    VueRecaptcha
  },
  ready: function () {
    this.focus = 'myMessage'
  },
  data () {
    return {
      myMessage: '',
      notSent: true,
      notSentError: false,
      focus: '',
      displaySendMessage: false
    }
  },
  directives: {
    focus: focus
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.$refs.myMessage.focus()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    onSubmit: function () {
      this.notSentError = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'sendMessage',
          data: this.myMessage
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.notSent = false
        } else {
          this.notSentError = true
        }
      })
    },
    exit: function () {
      this.$router.push({ path: '/' })
    },
    okC: function () {
      this.displaySendMessage = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// support.vue?2981e2b2